export default {"src":"/_next/static/media/help-circle_black.3ef6eff1.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};